import { connect } from 'react-redux'
import { ConfigProvider } from 'antd';

function defaultSelector(state) {
  const { intl, locales } = state;
  const localeAntd = locales[intl.locale] ? locales[intl.locale].antd : locales['en'].antd;
  return {
    locale: localeAntd,
  }
}

const mapStateToProps = (state, { intlSelector = defaultSelector }) =>
  intlSelector(state)

export default connect(mapStateToProps)(ConfigProvider)
